/**
 * @license
 * Copyright (c) 2016 The Polymer Project Authors. All rights reserved.
 * This code may only be used under the BSD style license found at http://polymer.github.io/LICENSE.txt
 * The complete set of authors may be found at http://polymer.github.io/AUTHORS.txt
 * The complete set of contributors may be found at http://polymer.github.io/CONTRIBUTORS.txt
 * Code distributed by Google as part of the polymer project is also
 * subject to an additional IP rights grant found at http://polymer.github.io/PATENTS.txt
 */

import '@polymer/iron-iconset-svg/iron-iconset-svg.js';
const $_documentContainer = document.createElement('template');
$_documentContainer.innerHTML = `<iron-iconset-svg name="cs-form-40" size="40" style="display: none;">
	<svg>
		<defs>
			<g id="success">
				<path d="M20,2A18,18,0,1,1,2,20,18.02,18.02,0,0,1,20,2m0-2A20,20,0,1,0,40,20,20,20,0,0,0,20,0h0Z"></path>
				<rect x="15.66" y="20.472" width="2.167" height="6.078" rx="1.083" ry="1.083" transform="translate(-11.721 18.725) rotate(-45)"></rect>
				<path d="M17.577,25.712h0a1.087,1.087,0,0,1-.109-1.528l6.353-7.66a1.087,1.087,0,0,1,1.528-.109h0a1.087,1.087,0,0,1,.109,1.528L19.105,25.6A1.087,1.087,0,0,1,17.577,25.712Z" fill-rule="evenodd"></path>
			</g>
			<g id="error">
				<path d="M20,2A18,18,0,1,1,2,20,18.02,18.02,0,0,1,20,2m0-2A20,20,0,1,0,40,20,20,20,0,0,0,20,0h0Z"></path>
				<path d="M17.868,26.35a2.232,2.232,0,0,1,.544-1.493A1.971,1.971,0,0,1,20,24.218a1.972,1.972,0,0,1,1.587.639,2.317,2.317,0,0,1,0,2.985,1.972,1.972,0,0,1-1.587.64,1.971,1.971,0,0,1-1.587-.64A2.228,2.228,0,0,1,17.868,26.35Zm2.154-4.387H19.676a0.87,0.87,0,0,1-.771-0.844l-0.58-4.7v-3.9a0.911,0.911,0,0,1,.781-1h1.471a0.911,0.911,0,0,1,.781,1v3.9l-0.564,4.693A0.871,0.871,0,0,1,20.022,21.963Z"></path>
			</g>
			<g id="ineligible">
				<path d="m20 40c-11.1 0-20-9-20-20 0-11.1 9-20 20-20 11.1 0 20 9 20 20 0 11.1-9 20-20 20zm0-2.4c9.8 0 17.7-7.9 17.7-17.7 0-9.8-7.9-17.7-17.7-17.7 -9.8 0-17.7 7.9-17.7 17.7 0 9.8 7.9 17.7 17.7 17.7zm8.3-26.9l-17.5 17.5 1.8 1.8 17.5-17.5 -1.8-1.8zm-17.5 1.8l17.5 17.5 1.8-1.8 -17.5-17.5 -1.8 1.8z"></path>
			</g>
		</defs>
	</svg>
</iron-iconset-svg>`;

document.head.appendChild($_documentContainer.content);
